import React from 'react';
import EllipsisTextWithTooltip from '../../../../../../../components/EllipsisTextWithTooltip/EllipsisTextWithTooltip';
import DropdownActions from '../../../ui/DropdownActions';
import { editActionNames as acceptanceEditActionNames } from '../../../../../shared/configs/acceptance';
import OpenChangeAcceptanceDateModal from '../../../controllers/OpenChangeAcceptanceDateModal';
import { acceptanceDateEntities } from '../../../../../api/acceptanceDateMutation';
import ToSetRoomsFromDatePage from '../../../controllers/ToSetRoomsFromDatePage';
import ToChangeMainDataPage from '../../../controllers/ToChangeMainDataPage';
import ToChangeDesksSettingsPage from '../../../controllers/ToChangeDesksSettingsPage';
import { useUserAcceptanceRole } from '../../../../../shared/hooks/userAcceptanceRole';
import styles from './index.module.scss';

const {
  changeFromDate: fromDateKey,
  changeToDate: toDateKey,
  setRoomsFromDate: roomsDateKey,
  changeMainData: mainDataKey,
  changeDesksSettings: desksSettingsKey,
} = acceptanceEditActionNames;

const editAcceptanceActions = [
  // {
  //   name: mainDataKey,
  //   component: <ToChangeMainDataPage />,
  // },
  {
    name: desksSettingsKey,
    component: <ToChangeDesksSettingsPage />,
  },
  {
    name: fromDateKey,
    component: (
      <OpenChangeAcceptanceDateModal dateType={acceptanceDateEntities.from}>
        Изменить дату начала приемки
      </OpenChangeAcceptanceDateModal>
    ),
  },
  {
    name: toDateKey,
    component: (
      <OpenChangeAcceptanceDateModal dateType={acceptanceDateEntities.to}>
        Изменить дату окончания приемки
      </OpenChangeAcceptanceDateModal>
    ),
  },
  {
    name: roomsDateKey,
    component: <ToSetRoomsFromDatePage />,
  },
];

const Header = ({ title, toggleViewSlot, massActionsSlot }) => {
  const role = useUserAcceptanceRole();

  return (
    <div className={styles.root}>
      <div className={styles.leftCol}>
        {title && (
          <div className={styles.titleWrapper}>
            <EllipsisTextWithTooltip as="p" className={styles.title}>
              {title}
            </EllipsisTextWithTooltip>
          </div>
        )}
        {role.isDirector && (
          <DropdownActions
            type={DropdownActions.types.acceptance}
            actions={editAcceptanceActions}
          />
        )}
      </div>
      <div className={styles.rightCol}>
        {massActionsSlot}
        {toggleViewSlot}
      </div>
    </div>
  );
};

export default Header;
